function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-email-log_svg__cls-3,.icon-email-log_svg__cls-4{stroke:var(--main-color);stroke-linecap:round;stroke-linejoin:round;stroke-width:8px;fill:none}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon-email-log_svg__Layer_4",
  "data-name": "Layer 4"
}, /*#__PURE__*/React.createElement("path", {
  d: "M51.76 204V65.52a10.07 10.07 0 0110.06-10.06h127.27a10.07 10.07 0 0110.06 10.06V204z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M189.09 59.46a6.07 6.07 0 016.06 6.06V200H55.76V65.52a6.07 6.07 0 016.06-6.06h127.27m0-8H61.82a14.07 14.07 0 00-14.06 14.06V208h155.39V65.52a14.06 14.06 0 00-14.06-14.06z",
  fill: "var(--main-color)"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-email-log_svg__cls-3",
  d: "M84.6 79.04h81.71M84.6 102.18h81.71"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-email-log_svg__cls-4",
  d: "M124 147c-34 0-71 56-71 56M125.48 147c34 0 71 56 71 56"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-email-log_svg__cls-3",
  d: "M98.07 156.07L53 118.35M153.05 155.79l45.07-37.72"
}));

function SvgIconEmailLog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 259 259"
  }, props), _ref, _ref2);
}

export default SvgIconEmailLog;